import React, { useMemo } from 'react';
import Icon from '@mdi/react';
import { mdiCheck } from '@mdi/js';

import './Modal.scss';
import useWindowDimensions from '../../../hooks/WindowDimensions';

const Modal = props => {

  const { width } = useWindowDimensions();

  const { responsive, position } = props;

  const theP = useMemo(() => {

    if (responsive && width < 420) {
      return {
        top: responsive.top,
        left: responsive.left,
        width: responsive.width,
        height: responsive.height,
      }
    } else if (position) {
      return {
        top: position.top,
        left: position.left,
        width: position.width,
        minWidth: position.minWidth,
        minHeight: position.minHeight,
        height: position.height,
        padding: position.padding
      }
    } else return null;
  }, [position, responsive, width]);

  return (
    <section
      className="Modal"
      style={{
        transform: props.text ? 'translateY(0)' : 'translateY(-100vh)',
        opacity: props.text ? '1' : '0',
        backgroundColor: props.text ? '#ffffff' : 'rgba(0, 0, 0, 0.7)',
        ...theP
      }}>

      {props.text}

      {props.onClick && <Icon color={'#333'} path={mdiCheck} title="OK" size={2.1} onClick={props.onClick} className="ok" />}
    </section>
  );
}

export default Modal;